import { TableSchema } from '../metadata-schema';
import { Plaatsingstatus } from '../enums/Plaatsingstatus';
import { dim_br_brin } from './dim_br_brin';
import { dim_ilt_opleidingscode } from './dim_ilt_opleidingscode';
import { dim_ll_leerling } from './dim_ll_leerling';
import { fac_or_onderwijsresultaten } from './fac_or_onderwijsresultaten';
import { dim_pc_postcode } from './dim_pc_postcode';
import { dim_vs_vestiging } from './dim_vs_vestiging';
import { BovenbouwsuccesUitzondering } from '../enums/BovenbouwsuccesUitzondering';
import { Bekostigingstype } from '../enums/Bekostigingstype';
import { UitstroomniveauVSO } from '../enums/UitstroomniveauVSO';
import { EinduitstroomVSOStatus } from '../enums/EinduitstroomVSOStatus';
import { Examenstatus } from '../enums/Examenstatus';
import { DoorstroomResultaat } from '../enums/DoorstroomResultaat';
import { Instroom } from '../enums/Instroom';
import { Instroomtype } from '../enums/Instroomtype';
import { Niveau } from '../enums/Niveau';
import { OnderbouwsnelheidUitzondering } from '../enums/OnderbouwsnelheidUitzondering';
import { OnderwijspositieUitzondering } from '../enums/OnderwijspositieUitzondering';
import { Uitstroom } from '../enums/Uitstroom';
import { Uitstroommoment } from '../enums/Uitstroommoment';
import { Uitstroomtype } from '../enums/Uitstroomtype';
import { UitstroomtypeVSO } from '../enums/UitstroomtypeVSO';

export const fac_lb_loopbaan: TableSchema = {
	"$schema": "https://json-schema.org/draft/2020-12/schema",
	"title": "fac_lb_loopbaan",
	"description": "Definitie voor fact tabel fac_lb_loopbaan uit de CumLaude DWH",
	"type": "object",
	"implements": [
		"nl.topicus.cumlaude.metadata.table.FacTable",
		"nl.topicus.cumlaude.metadata.table.Leerlingspecifiek",
		"nl.topicus.cumlaude.metadata.table.Vestigingspecifiek"
	],
	"properties": {
		"lb_abb_leerfase": {
			"type": "string",
			"label": "Leerfase (afk)",
			"category": "Opleiding",
			"example": "h3, bk1, lj2",
			"description": "Afkorting van de leerfase waarin deze leerling geplaatst is.\nDit is de combinatie van niveau en leerjaar, waarbij het niveau als één letter\nwordt weergegeven: (p, b, k, t, h, v voor resp. PrO, VMBO b, k en (g)t, HAVO en VWO).\nVoor combinatieniveaus worden twee letters gebruikt."
		},
		"lb_co_brin": {
			"type": "string",
			"label": "Instellingscode",
			"searchKeys": [
				"BRIN"
			],
			"category": "School",
			"example": "01XX",
			"description": "Het BRIN-nummer van de instelling waarop deze leerling is ingeschreven."
		},
		"lb_co_brin_svb": {
			"type": "string",
			"label": "Instellingscode SvB",
			"category": "Vervolgopleiding",
			"searchKeys": [
				"school van bestemming",
				"BRIN",
				"BRIN SvB"
			],
			"example": "02AA",
			"description": "Het BRIN-nummer van de school van bestemming, als de leerling dit schooljaar de instelling verlaat.\nDit is de vervolgschool zoals vastgelegd bij de beëindiging van de registratie."
		},
		"lb_co_brin_svh": {
			"type": "string",
			"label": "Instellingscode SvH",
			"category": "Vooropleiding",
			"searchKeys": [
				"school van herkomst",
				"BRIN",
				"BRIN SvH"
			],
			"example": "02AA",
			"description": "Het BRIN-nummer van de school van herkomst.\nDit kan zowel een basisschool zijn als een VO-school, afhankelijk van wat in het bronsysteem is ingericht."
		},
		"lb_co_brin_vestiging": {
			"type": "string",
			"label": "Vestigingscode",
			"searchKeys": [
				"BRIN",
				"BRIN (vestiging)"
			],
			"category": "School",
			"example": "01XX00",
			"description": "Het BRIN-nummer inclusief vestigingsvolgnummer van de vestiging waarop deze leerling is geplaatst."
		},
		"lb_co_brinvest_volgend_pl": {
			"type": "string",
			"filter": false,
			"grouping": false,
			"exportable": false
		},
		"lb_co_niveau_volgend_sj": {
			"type": "integer",
			"filter": false,
			"grouping": false,
			"exportable": false
		},
		"lb_d_1okt": {
			"type": "string",
			"format": "date",
			"filter": false,
			"grouping": false,
			"exportable": false,
			"description": "De volledige datum waarop 1 oktober valt in het schooljaar van deze plaatsing."
		},
		"lb_d_examen": {
			"type": "string",
			"format": "date",
			"label": "Examendatum",
			"category": "Examen",
			"example": "13-06-2023",
			"description": "De datum waarop de leerling is geslaagd of afgewezen.\nAlleen gevuld bij leerlingen met een examenuitslag."
		},
		"lb_d_plaatsing_va": {
			"type": "string",
			"format": "date",
			"label": "Plaatsing vanaf",
			"category": "Plaatsing",
			"example": "01-08-2022",
			"description": "Begindatum van deze plaatsing."
		},
		"lb_d_plaatsing_tm": {
			"type": "string",
			"format": "date",
			"label": "Plaatsing t/m",
			"category": "Plaatsing",
			"example": " 31-07-2023",
			"description": "Einddatum van deze plaatsing."
		},
		"lb_d_inschrijving": {
			"type": "string",
			"format": "date",
			"label": "Inschrijvingsdatum",
			"filter": false,
			"grouping": false,
			"exportable": false
		},
		"lb_d_instroom_in_schooljaar": {
			"type": "string",
			"format": "date",
			"label": "Datum instroom",
			"category": "Instroom - Uitstroom",
			"example": "15-10-2022",
			"description": "Geeft aan op welke datum deze leerling dit schooljaar is ingestroomd vanuit een andere school of een andere vestiging binnen deze instelling. Leeg indien niet ingestroomd."
		},
		"lb_d_uitschrijving": {
			"type": "string",
			"format": "date",
			"label": "Uitschrijvingsdatum",
			"filter": false,
			"grouping": false,
			"exportable": false
		},
		"lb_des_plaatsingstatus": {
			"label": "Plaatsingstatus",
			"category": "Plaatsing",
			"example": "Definitief, Voorlopig",
			"description-somtoday": "Status van deze plaatsing in Somtoday: Voorlopig of Definitief.\nVoorlopige plaatsingen en overgangen naar voorlopige plaatsingen worden in CumLaude als \"prognose\" weergegeven.",
			"description-magister": "Status van deze plaatsing in Magister: Voorlopig of Definitief.\nVoorlopige plaatsingen en overgangen naar voorlopige plaatsingen worden in CumLaude als \"prognose\" weergegeven.",
			"type": "string",
			"schema": Plaatsingstatus
		},
		"lb_fk_br_vest": {
			"description": "Definitie voor dimension tabel dim_br_brin uit de CumLaude DWH",
			"type": "object",
			"schema": dim_br_brin
		},
		"lb_fk_br_vest_volgend_pl": {
			"description": "Definitie voor dimension tabel dim_br_brin uit de CumLaude DWH",
			"type": "object",
			"schema": dim_br_brin
		},
		"lb_fk_ilt": {
			"description": "Definitie voor dimension tabel dim_ilt_opleidingscode uit de CumLaude DWH",
			"type": "object",
			"schema": dim_ilt_opleidingscode
		},
		"lb_fk_ilt_volgend_pl": {
			"description": "Definitie voor dimension tabel dim_ilt_opleidingscode uit de CumLaude DWH",
			"type": "object",
			"schema": dim_ilt_opleidingscode
		},
		"lb_fk_ilt_volgend_sj": {
			"description": "Definitie voor dimension tabel dim_ilt_opleidingscode uit de CumLaude DWH",
			"type": "object",
			"schema": dim_ilt_opleidingscode
		},
		"lb_fk_ll": {
			"description": "Definitie voor dimension tabel dim_ll_leerling uit de CumLaude DWH",
			"type": "object",
			"schema": dim_ll_leerling
		},
		"lb_fk_or_bbscl": {
			"description": "Definitie voor fact tabel fac_or_onderwijsresultaten uit de CumLaude DWH.\nEen onderwijsresultaat uit het onderwijsresultatenmodel aan de hand waarvan de Onderwijsinspectie alle VO-scholen beoordeelt.\nIedere rij stelt één onderwijsresultaat voor: een score op één van de vier indicatoren over één schooljaar voor één vestiging en eventueel niveau (alleen Bovenbouwsucces/Examencijfers).\nIn de beoordeling van een bepaald peiljaar berekent de inspectie voor iedere indicator het gemiddelde van de onderwijsresultaten over de 3 voorafgaande schooljaren. Er wordt ook een gemiddelde berekend als van slechts twee schooljaren, waaronder het meest recente schooljaar, gegevens bekend zijn.",
			"type": "object",
			"schema": fac_or_onderwijsresultaten
		},
		"lb_fk_or_obscl": {
			"description": "Definitie voor fact tabel fac_or_onderwijsresultaten uit de CumLaude DWH.\nEen onderwijsresultaat uit het onderwijsresultatenmodel aan de hand waarvan de Onderwijsinspectie alle VO-scholen beoordeelt.\nIedere rij stelt één onderwijsresultaat voor: een score op één van de vier indicatoren over één schooljaar voor één vestiging en eventueel niveau (alleen Bovenbouwsucces/Examencijfers).\nIn de beoordeling van een bepaald peiljaar berekent de inspectie voor iedere indicator het gemiddelde van de onderwijsresultaten over de 3 voorafgaande schooljaren. Er wordt ook een gemiddelde berekend als van slechts twee schooljaren, waaronder het meest recente schooljaar, gegevens bekend zijn.",
			"type": "object",
			"schema": fac_or_onderwijsresultaten
		},
		"lb_fk_or_opcl": {
			"description": "Definitie voor fact tabel fac_or_onderwijsresultaten uit de CumLaude DWH.\nEen onderwijsresultaat uit het onderwijsresultatenmodel aan de hand waarvan de Onderwijsinspectie alle VO-scholen beoordeelt.\nIedere rij stelt één onderwijsresultaat voor: een score op één van de vier indicatoren over één schooljaar voor één vestiging en eventueel niveau (alleen Bovenbouwsucces/Examencijfers).\nIn de beoordeling van een bepaald peiljaar berekent de inspectie voor iedere indicator het gemiddelde van de onderwijsresultaten over de 3 voorafgaande schooljaren. Er wordt ook een gemiddelde berekend als van slechts twee schooljaren, waaronder het meest recente schooljaar, gegevens bekend zijn.",
			"type": "object",
			"schema": fac_or_onderwijsresultaten
		},
		"lb_fk_pc_leerling": {
			"description": "Definitie voor dimension tabel dim_pc_postcode uit de CumLaude DWH",
			"type": "object",
			"schema": dim_pc_postcode
		},
		"lb_fk_vs": {
			"description": "Definitie voor dimension tabel dim_vs_vestiging uit de CumLaude DWH",
			"type": "object",
			"schema": dim_vs_vestiging
		},
		"lb_fk_vs_bekostiging": {
			"description": "Definitie voor dimension tabel dim_vs_vestiging uit de CumLaude DWH",
			"type": "object",
			"schema": dim_vs_vestiging
		},
		"lb_fk_vs_volgend_pl": {
			"description": "Definitie voor dimension tabel dim_vs_vestiging uit de CumLaude DWH",
			"type": "object",
			"schema": dim_vs_vestiging
		},
		"lb_id_vestiging": {
			"type": "string",
			"filter": false,
			"grouping": false,
			"exportable": false,
			"allowlist": {
				"beheer": true
			}
		},
		"lb_is_1febr_plaatsing": {
			"type": "integer",
			"minimum": 0,
			"maximum": 1,
			"label": "1-februariplaatsing",
			"filter": false,
			"grouping": false,
			"exportable": false
		},
		"lb_is_1okt_plaatsing": {
			"type": "integer",
			"minimum": 0,
			"maximum": 1,
			"label": "1-oktoberplaatsing",
			"filter": false,
			"grouping": false,
			"exportable": false
		},
		"lb_is_afgewezen": {
			"type": "integer",
			"minimum": 0,
			"maximum": 1,
			"filter": false,
			"grouping": false,
			"exportable": false
		},
		"lb_is_apcg": {
			"type": "integer",
			"minimum": 0,
			"maximum": 1,
			"label": "APCG",
			"category": "Kenmerk",
			"searchKeys": [
				"Armoedeprobleemcumulatiegebied",
				"postcode"
			],
			"example": "Ja, Nee",
			"description": "Geeft aan of de postcode van het woonadres van deze leerling valt in een armoedeprobleemcumulatiegebied (APCG).\nHet percentage leerlingen woonachtig in een APCG is van invloed op de correctiefactoren die de inspectie toepast op de norm van de\nindicatoren Onderbouwsnelheid, Bovenbouwsucces en Examencijfers."
		},
		"lb_is_bekostigd": {
			"type": "integer",
			"minimum": 0,
			"maximum": 1,
			"label": "Bekostigbaar",
			"category": "Plaatsing",
			"example": "Ja, Nee",
			"description-magister": "Nee als de aanmelding van deze leerling in Magister is aangemerkt als niet-bekostigbaar of extraneus.\nJa in alle andere gevallen.",
			"description-somtoday": "Nee als het bekostingstype van deze plaatsing op \"Niet bekostigbaar\" staat.\nJa in alle andere gevallen."
		},
		"lb_is_bevorderd": {
			"type": "integer",
			"minimum": 0,
			"maximum": 1,
			"label": "Bevorderd",
			"category": "Doorstroom",
			"example": "Ja, Nee",
			"description": "Ja als de leerling volgend schooljaar in een hoger leerjaar is geplaatst (ongeacht niveau), geslaagd is of uitstroomt met vertrekstatus\nBevorderd of Geslaagd.\nNee in overige gevallen."
		},
		"lb_is_doublure": {
			"type": "integer",
			"minimum": 0,
			"maximum": 1,
			"filter": false,
			"grouping": false,
			"exportable": false,
			"description": "Ja als de leerling niet geslaagd is en volgend schooljaar in een gelijk of lager leerjaar is geplaatst (ongeacht niveau), zonder\ndiploma uitstroomt naar het MBO, of uitstroomt met vertrekstatus Doublure of Niet bevorderd.\nNee in overige gevallen."
		},
		"lb_is_examenkandidaat": {
			"type": "integer",
			"minimum": 0,
			"maximum": 1,
			"label": "Examenkandidaat",
			"category": "Examen",
			"example": "Ja, Nee",
			"description-somtoday": "Ja als de leerling in het laatste jaar van een examenopleiding is geplaatst en een examendeelname met status Aangemeld, Geslaagd of\nAfgewezen heeft, of uitstroomt met vertrekstatus Geslaagd of Afgewezen.\nNee in overige gevallen.",
			"description-magister": "Ja als de leerling in het laatste jaar van een examenopleiding is geplaatst, niet is teruggetrokken en in niet-actuele schooljaren een\nexamenuitslag heeft (Geslaagd of Afgewezen).\nNee in overige gevallen."
		},
		"lb_is_examenopleiding": {
			"type": "integer",
			"minimum": 0,
			"maximum": 1,
			"label": "Examenopleiding",
			"category": "Examen",
			"example": "Ja, Nee",
			"description": "Ja als de leerling in het laatste jaar van een examenopleiding is geplaatst. Nee in overige gevallen."
		},
		"lb_is_examenopstroom": {
			"type": "integer",
			"minimum": 0,
			"maximum": 1,
			"label": "Examenopstroom",
			"category": "Kenmerk",
			"example": "Ja, Nee",
			"description-somtoday": "Ja als de leerling een examenopstromer is.\nHiervan is sprake als de leerling tijdens een eerdere plaatsing geslaagd is voor een lager niveau, of wanneer bij de school van herkomst\nhet veld \"Diploma behaald\" gevuld is met een lager niveau.\nNee in overige gevallen.",
			"description-magister": "Ja als de leerling een examenopstromer is.\nHiervan is sprake als de leerling al een diploma van een lager niveau in bezit heeft.\nNee in overige gevallen."
		},
		"lb_is_extraneus": {
			"type": "integer",
			"minimum": 0,
			"maximum": 1,
			"label": "Extraneus",
			"category": "Kenmerk",
			"example": "Ja, Nee",
			"description": "Ja als deze examenkandidaat op 1 oktober niet was ingeschreven op deze instelling (BRIN4).\nExtraneï tellen niet mee voor Bovenbouwsucces en Examencijfers."
		},
		"lb_is_geemigreerd": {
			"type": "integer",
			"minimum": 0,
			"maximum": 1,
			"filter": false,
			"grouping": false,
			"exportable": false
		},
		"lb_is_geldig_bbs": {
			"type": "integer",
			"minimum": 0,
			"maximum": 1,
			"filter": false,
			"grouping": false,
			"exportable": false
		},
		"lb_is_geldig_obs": {
			"type": "integer",
			"minimum": 0,
			"maximum": 1,
			"filter": false,
			"grouping": false,
			"exportable": false
		},
		"lb_is_geldig_op": {
			"type": "integer",
			"minimum": 0,
			"maximum": 1,
			"filter": false,
			"grouping": false,
			"exportable": false
		},
		"lb_is_geslaagd": {
			"type": "integer",
			"minimum": 0,
			"maximum": 1,
			"filter": false,
			"grouping": false,
			"exportable": false
		},
		"lb_is_instroom_extern": {
			"type": "integer",
			"minimum": 0,
			"maximum": 1,
			"filter": false,
			"grouping": false,
			"exportable": false
		},
		"lb_is_instroom_andere_instellingscode": {
			"type": "integer",
			"minimum": 0,
			"maximum": 1,
			"label": "Instroom van andere instellingscode",
			"category": "Instroom - Uitstroom",
			"example": "Ja, Nee",
			"description": "Geeft aan of er dit schooljaar instroom heeft plaatsgevonden vanuit een andere instellingscode.\nDit is het geval als de leerling voorheen een plaatsing had bij een vestiging met een andere instellingscode (BRIN4), of als de leerling extern instroomt."
		},
		"lb_is_instroom_intern": {
			"type": "integer",
			"minimum": 0,
			"maximum": 1,
			"filter": false,
			"grouping": false,
			"exportable": false
		},
		"lb_is_laatste_plaatsing_sj": {
			"type": "integer",
			"minimum": 0,
			"maximum": 1,
			"label": "Laatste plaatsing schooljaar",
			"category": "Plaatsing",
			"example": "Ja, Nee",
			"description": "Ja als dit de laatste plaatsing van deze leerling binnen dit schooljaar is. Nee in overige gevallen."
		},
		"lb_is_nieuwkomer_2jaar": {
			"type": "integer",
			"minimum": 0,
			"maximum": 1,
			"label": "Nieuwkomer (2 jaar)",
			"category": "Kenmerk",
			"example": "Ja, Nee",
			"description": "Ja als de leerling geen Nederlandse nationaliteit heeft en op 1 oktober van dit schooljaar korter dan 2 jaar in Nederland verblijft.\nNee in overige gevallen."
		},
		"lb_is_nieuwkomer_4jaar": {
			"type": "integer",
			"minimum": 0,
			"maximum": 1,
			"label": "Nieuwkomer (4 jaar)",
			"category": "Kenmerk",
			"example": "Ja, Nee",
			"description": "Ja als de leerling geen Nederlandse nationaliteit heeft en op 1 oktober van dit schooljaar korter dan 4 jaar in Nederland verblijft.\nNee in overige gevallen."
		},
		"lb_is_pl_voorlopig": {
			"type": "integer",
			"minimum": 0,
			"maximum": 1,
			"label": "Voorlopige plaatsing",
			"category": "Plaatsing",
			"example": "Ja, Nee",
			"description": "Ja als deze plaatsing status Voorlopig heeft. Nee als deze plaatsing status Definitief heeft."
		},
		"lb_is_succesvol": {
			"type": "integer",
			"minimum": 0,
			"maximum": 1,
			"label": "Succesvol",
			"category": "Doorstroom",
			"example": "Ja, Nee",
			"description": "Ja als deze leerling is bevorderd (mits niet afgestroomd), geslaagd is, opstroomt naar een hoger niveau in hetzelfde leerjaar, of\nuitstroomt met vertrekstatus Bevorderd of Geslaagd.\nNee in overige gevallen."
		},
		"lb_is_rod_communicatie": {
			"type": "integer",
			"minimum": 0,
			"maximum": 1,
			"label": "ROD-communicatie",
			"searchKeys": [
				"DUO",
				"BRON"
			],
			"category": "Plaatsing",
			"example": "Ja, Nee",
			"description-somtoday": "Nee als de leerling in Somtoday is gemarkeerd als \"Niet versturen naar ROD\".\nJa in alle andere gevallen.",
			"description-magister": "Nee als de leerling in Magister is gemarkeerd als \"Aanmelding niet naar DUO\".\nJa in alle andere gevallen."
		},
		"lb_is_uitstroom_andere_instellingscode": {
			"type": "integer",
			"minimum": 0,
			"maximum": 1,
			"label": "Uitstroom naar andere instellingscode",
			"category": "Instroom - Uitstroom",
			"example": "Ja, Nee",
			"description": "Geeft aan of er dit schooljaar uitstroom plaatsvindt naar een andere instellingscode.\nDit is het geval als de leerling een vervolgplaatsing heeft bij een vestiging met een andere instellingscode (BRIN4), of als de leerling extern uitstroomt."
		},
		"lb_is_uitstroom_extern": {
			"type": "integer",
			"minimum": 0,
			"maximum": 1,
			"filter": false,
			"grouping": false,
			"exportable": false
		},
		"lb_is_uitstroom_vavo": {
			"type": "integer",
			"minimum": 0,
			"maximum": 1,
			"filter": false,
			"grouping": false,
			"exportable": false
		},
		"lb_is_vest_relevant_sj": {
			"type": "integer",
			"minimum": 0,
			"maximum": 1,
			"filter": false,
			"grouping": false,
			"exportable": false
		},
		"lb_nm_bbs_uitzondering": {
			"filter": false,
			"grouping": false,
			"exportable": false,
			"description": "Geeft aan of er een bijzondere situatie van toepassing is op deze leerling waardoor deze plaatsing niet meetelt voor de indicator Bovenbouwsucces:\n- Regulier bovenbouwsucces: geen uitzondering van toepassing; de plaatsing telt mee voor het bovenbouwsucces.\n- VSO: de leerling is geplaatst op het VSO; het bovenbouwsucces is niet van toepassing.\n- Geen bovenbouw: de leerling zit niet in leerjaar 3, 4, 5 of 6.\n- Geen relevante plaatsing: deze plaatsing is niet de plaatsing van de leerling die relevant is voor het bovenbouwsucces. De relevante\nplaatsing is de plaatsing die actief is op 1 oktober.\n- Geen 1-oktoberplaatsing: deze plaatsing is beëindigd vóór 1 oktober van dit schooljaar.\n- Tussentijdse instroom: deze plaatsing begint na 1 oktober van dit schooljaar.\n- Doorstroom hoger onderwijs zonder uitslag: de leerling stroomt zonder uitslag vanuit VMBO of HAVO door naar het Hoger Onderwijs.\nDeze groep leerlingen wordt buiten beschouwing gelaten. VWO-leerlingen die zonder uitslag naar het HO gaan, tellen wel mee en zijn niet\nsuccesvol.\n- Overgang naar praktijkonderwijs: leerlingen die uitstromen naar het praktijkonderwijs tellen niet mee voor het bovenbouwsucces.\n- Uitgesloten van ROD-communicatie: de leerling is uitgesloten van ROD-communicatie en telt niet mee bij het bovenbouwsucces.\n- VAVO leerling: VAVO-leerlingen tellen niet mee voor het bovenbouwsucces.\n- Internationale leerling: leerlingen met de internationale opleidingen \"International Baccalaureate\" en \"European Secondary School\"\ntellen niet mee voor het bovenbouwsucces.\n- Nieuwkomer: de leerling verblijft op 1 oktober van dit schooljaar korter dan 2 jaar in Nederland en telt daarom niet mee voor het\nbovenbouwsucces.\n- Uitstroom speciaal onderwijs: leerlingen die uitstromen naar het speciaal onderwijs tellen niet mee voor het bovenbouwsucces.\n- Vakmanschap/technologie-route: tot schooljaar 2018/2019 telden leerlingen in de vakmanschap/technologie-route niet mee voor het\nbovenbouwsucces.",
			"type": "string",
			"schema": BovenbouwsuccesUitzondering
		},
		"lb_nm_bekostigingstype": {
			"label": "Bekostigingstype",
			"category": "Plaatsing",
			"example": "Standaard, ExternOnderwijs, NietBekostigbaar",
			"description-somtoday": "Het bekostigingstype van deze plaatsing zoals vastgelegd in Somtoday.",
			"description-magister": "NietBekostigbaar als de aanmelding van deze leerling in Magister is aangemerkt als niet te bekostigen of als extraneus.\nStandaard in overige gevallen.",
			"type": "string",
			"schema": Bekostigingstype
		},
		"lb_nm_beoogd_uitstroomniveau_vso": {
			"label": "Beoogd uitstroomniveau",
			"category": "Prestatieanalyse",
			"example": "MBO niveau 2, HBO, Dagbesteding arbeidsmatig, ...",
			"description": "Het in het ontwikkelingsperspectief (OPP) vastgelegde beoogde uitstroomniveau voor deze leerling.\nBij leerlingen met meerdere OPP's is het OPP met de nieuwste begindatum bepalend.\nHet beoogde uitstroomniveau speelt een rol in de Prestatieanalyse voor de indicatoren \"Behaald uitstroomniveau op school conform OPP\" en \"Beoogd i.r.t. behaald einduitstroomniveau\":\nvoor beide indicatoren wordt dit niveau vergeleken met het _behaalde uitstroomniveau_, dat is vastgelegd bij de uitschrijvingsgegevens (registratie) van de leerling.",
			"blocklist": {
				"geenVSO": true
			},
			"type": "string",
			"schema": UitstroomniveauVSO
		},
		"lb_nm_einduitstroom_vso_status": {
			"filter": false,
			"grouping": false,
			"exportable": false,
			"type": "string",
			"schema": EinduitstroomVSOStatus
		},
		"lb_nm_examenstatus": {
			"label": "Examenstatus",
			"category": "Examen",
			"searchKeys": [
				"Geslaagd",
				"Afgewezen",
				"Teruggetrokken",
				"Voorlaatste jaar",
				"Gespreid examen",
				"Gezakt"
			],
			"example": "Geslaagd, Afgewezen, Voortijdig teruggetrokken, ...",
			"description": "De uitslag van het examen of de status waarin het examen zich bevindt:\n- Geslaagd: de leerling is geslaagd of is uitgeschreven met vertrekstatus Geslaagd.\n- Afgewezen: de leerling is afgewezen (gezakt) of is uitgeschreven met vertrekstatus Afgewezen.\n- Teruggetrokken: de leerling heeft zich voor of tijdens het examen teruggetrokken en niet langer examenkandidaat.\n- Voorlaatste jaar: de leerling zit in het (voor)voorlaatste jaar van de opleiding en doet dit jaar in één of meer vakken examen.\n- Gespreid examen: de leerling zit in het eerste jaar van een gespreid examen en doet dit jaar examen in een deel van de vakken.",
			"type": "string",
			"schema": Examenstatus
		},
		"lb_nm_idu": {
			"label": "Doorstroom",
			"category": "Doorstroom",
			"searchKeys": [
				"Opstroom",
				"Afstroom",
				"Doorstroom",
				"Geslaagd",
				"Afgewezen"
			],
			"example": "Doorstroom, Geslaagd, Afstroom, ...",
			"description": "Het \"resultaat\" van deze plaatsing, bepaald op basis van de plaatsing in volgend schooljaar, het examen en/of uitstroomgegevens.\n- Afstroom: de leerling is volgend schooljaar geplaatst in een lager niveau.\n- Opstroom: de leerling is volgend schooljaar geplaatst in een hoger niveau. Dit kan examenopstroom of reguliere opstroom zijn.\n- Geslaagd: de leerling is geslaagd of uitgeschreven met vertrekstatus Geslaagd.\n- Doublure: de leerling is niet geslaagd en is volgend schooljaar in een gelijk of lager leerjaar geplaatst (ongeacht niveau), \nof stroomt zonder diploma uit naar het MBO, of stroomt uit met vertrekstatus Doublure of Niet bevorderd.\n- Afgewezen: de leerling is afgewezen of uitgeschreven met vertrekstatus Afgewezen.\n- Doorstroom: de leerling is volgend schooljaar geplaatst in een hoger leerjaar van hetzelfde niveau.",
			"type": "string",
			"schema": DoorstroomResultaat
		},
		"lb_nm_instroom": {
			"label": "Instroom",
			"filter": false,
			"grouping": false,
			"exportable": false,
			"type": "string",
			"schema": Instroom
		},
		"lb_nm_instroom_in_schooljaar": {
			"label": "Instroom",
			"category": "Instroom - Uitstroom",
			"example": "Extern, Intern, Extern (tussentijds), Geen, ...",
			"description": "Geeft aan of er dit schooljaar instroom heeft plaatsgevonden en welke vorm van instroom:\n- Extern: de leerling is vóór of op 1 oktober van dit schooljaar ingestroomd vanaf een andere school buiten deze instelling.\nDe leerling is nooit eerder ingeschreven geweest op deze instelling of is minimaal 60 dagen uitgeschreven geweest.\n- Extern (tussentijds): de leerling is na 1 oktober van dit schooljaar ingestroomd vanaf een andere school buiten deze instelling.\nDe leerling is nooit eerder ingeschreven geweest op deze instelling of is minimaal 60 dagen uitgeschreven geweest.\n- Intern: de leerling is vóór of op 1 oktober van dit schooljaar ingestroomd vanaf een andere vestiging binnen deze instelling naar deze\nvestiging.\n- Intern (tussentijds): de leerling is na 1 oktober van dit schooljaar ingestroomd vanaf een andere vestiging binnen deze instelling\nnaar deze vestiging.",
			"type": "string",
			"schema": Instroom
		},
		"lb_nm_instroomtype": {
			"filter": false,
			"grouping": false,
			"exportable": false,
			"type": "string",
			"schema": Instroomtype
		},
		"lb_nm_instroomtype_in_schooljaar": {
			"label": "Instroomtype",
			"category": "Instroom - Uitstroom",
			"example": "Extern, Intern",
			"description": "Geeft aan of er dit schooljaar instroom heeft plaatsgevonden en welk type instroom:\n- Extern: de leerling is ingestroomd vanaf een andere school buiten deze instelling.\nDe leerling is nooit eerder ingeschreven geweest op deze instelling of is minimaal 60 dagen uitgeschreven geweest.\n- Intern: de leerling is ingestroomd vanaf een andere vestiging binnen deze instelling naar deze vestiging.",
			"type": "string",
			"schema": Instroomtype
		},
		"lb_nm_klas": {
			"type": "string",
			"label": "Klas",
			"category": "Opleiding",
			"example": "1V2, 2B3, 3H4, ...",
			"description-somtoday": "De stamgroep waarin de leerling geplaatst is.",
			"description-magister": "De klas waarin de leerling geplaatst is."
		},
		"lb_nm_klas_volgend_pl": {
			"type": "string",
			"filter": false,
			"grouping": false,
			"exportable": false
		},
		"lb_nm_leerfase": {
			"type": "string",
			"label": "Leerfase",
			"category": "Opleiding",
			"example": "HAVO 3, VMBO b/k 1, OND 2",
			"description": "De combinatie van niveau en leerjaar waarin de leerling geplaatst is.",
			"allowlist": {
				"beheer": true
			}
		},
		"lb_nm_lichting": {
			"type": "string",
			"label": "Lichting",
			"category": "Opleiding",
			"example": "VWO 2020-2023, VMBO Basisberoepsgerichte leerweg 2021-2023, ...",
			"description-somtoday": "De lichting of het cohort waar de leerling deel van uitmaakt. Dit is de combinatie van niveau\nen schooljaar, waarbij meerjarige bovenbouwopleidingen een periode van 2 of 3\nachtereenvolgende schooljaren beslaan. De leerling blijft gedurende deze periode\nbij reguliere doorstroom in dezelfde lichting. De lichting van de leerling \nkan in het geval van vak op hoger niveau of examen in het voorlaatste jaar, afwijken\nvan de lichting waarin de leerling een specifiek vak volgt."
		},
		"lb_nm_niveau_volgend_sj": {
			"filter": false,
			"grouping": false,
			"exportable": false,
			"description": "Het niveau waarin de leerling op 1 oktober van het volgende schooljaar geplaatst is.",
			"type": "string",
			"schema": Niveau
		},
		"lb_nm_obs_uitzondering": {
			"filter": false,
			"grouping": false,
			"exportable": false,
			"description": "Geeft aan of er een bijzondere situatie van toepassing is op deze leerling waardoor deze plaatsing niet meetelt voor de indicator Onderbouwsnelheid:\n- Reguliere onderbouwsnelheid: geen uitzondering van toepassing; de plaatsing telt mee voor de onderbouwsnelheid.\n- VSO: de leerling is geplaatst op het VSO; de onderbouwsnelheid is niet van toepassing.\n- Geen onderbouw: de leerling is niet geplaatst in leerjaar 1 of 2.\n- Geen 1-oktoberplaatsing: deze plaatsing is beëindigd vóór 1 oktober van dit schooljaar.\n- Tussentijdse instroom: deze plaatsing begint na 1 oktober van dit schooljaar.\n- Uitgesloten van ROD-communicatie: de leerling is uitgesloten van ROD-communicatie en telt niet mee bij de onderbouwsnelheid.\n- Emigratie: leerlingen die het Nederlands VO verlaten tellen niet mee voor de onderbouwsnelheid.\n- Uitstroom speciaal onderwijs: leerlingen die uitstromen naar het speciaal onderwijs tellen niet mee voor de onderbouwsnelheid.\n- Uitstroom/Geen VO: leerlingen die het Nederlands VO verlaten tellen niet mee voor de onderbouwsnelheid.\n- Internationale leerling: leerlingen met de internationale opleidingen \"International Baccalaureate\" en \"European Secondary School\"\ntellen niet mee voor de onderbouwsnelheid.\n- PrO-leerling: leerlingen die uitstromen naar het praktijkonderwijs tellen niet mee voor de onderbouwsnelheid.\n- VAVO leerling: VAVO-leerlingen tellen niet mee voor de onderbouwsnelheid.\n- Nieuwkomer: de leerling verblijft op 1 oktober van dit schooljaar korter dan 2 jaar in Nederland en telt daarom niet mee voor de\nonderbouwsnelheid.",
			"type": "string",
			"schema": OnderbouwsnelheidUitzondering
		},
		"lb_nm_onderwijssoort": {
			"type": "string",
			"label": "Onderwijssoort",
			"category": "Opleiding",
			"example": "Praktijkonderwijs, VMBO Theoretische leerweg tweetalig, Gymnasium, ...",
			"description-somtoday": "De onderwijssoort van deze opleiding zoals ingericht in Somtoday.\nDit veld is iets fijnmaziger dan het niveau van de opleiding, dat wordt afgeleid\nuit de officiële opleidingscode (ILT-code). Zo kan er onderscheid worden gemaakt\ntussen tweetalig en regulier onderwijs, en kan bij een breed onderbouwniveau\nzoals VMBO/HAVO/VWO een specifiekere onderwijssoort worden aangeduid.\nNB. CumLaude gebruikt, net als de Inspectie, voor de meeste overzichten het \nniveau van de opleiding, zoals afgeleid uit de officiële opleidingscode \n(ILT-code). Brede onderbouwniveaus worden hierin weergegeven als OND."
		},
		"lb_nm_opleiding": {
			"type": "string",
			"label": "Opleiding",
			"category": "Opleiding",
			"example": "Brugklas, HAVO 3, VWO NT & NG, ...",
			"description-somtoday": "De naam van de opleiding zoals ingericht in Somtoday.",
			"description-magister": "De naam van de studie zoals ingericht in Magister."
		},
		"lb_nm_opleiding_bekostiging": {
			"type": "string",
			"filter": false,
			"grouping": false,
			"exportable": false
		},
		"lb_nm_op_uitzondering": {
			"filter": false,
			"grouping": false,
			"exportable": false,
			"description": "Geeft aan of er een bijzondere situatie van toepassing is op deze leerling waardoor deze plaatsing niet meetelt voor de indicator\nOnderwijspositie t.o.v. advies PO:\n- Reguliere onderwijspositie: geen uitzondering van toepassing; de plaatsing telt mee voor de onderwijspositie.\n- VSO: de leerling is geplaatst op het VSO; de onderwijspositie is niet van toepassing.\n- Geen relevante plaatsing: deze plaatsing is niet de plaatsing van de leerling die relevant is voor de onderwijspositie. De relevante\nplaatsing is de plaatsing die actief is op 1 oktober.\n- Geen 1-oktoberplaatsing: deze plaatsing is beëindigd vóór 1 oktober van dit schooljaar.\n- Tussentijdse instroom: deze plaatsing begint na 1 oktober van dit schooljaar.\n- Geen leerjaar 2: deze plaatsing betreft niet leerjaar 2. Voor de onderwijspositie wordt de plaatsing gezocht waarin de leerling over\ngaat van leerjaar 2 naar 3.\n- Andere school/vestiging in leerjaar 1: deze leerling had in leerjaar 1 een andere vestiging (BRIN) dan in leerjaar 2.\nHierdoor wordt deze leerling bij de bepaling van de onderwijspositie buiten beschouwing gelaten, omdat het verschil tussen het\nbasisschooladvies en de onderwijspositie in leerjaar 3 niet kan worden toegeschreven aan één vestiging.\n- Advies breder dan 3: de leerling heeft een basisschooladvies dat meer dan 3 niveaus beslaat, zoals VMBO b t/m HAVO. Bij adviezen van 2\nniveaus wordt het laagste niveau gebruikt; bij adviezen van 3 niveaus het middelste. Adviezen van meer dan 3 niveaus zijn niet\nbruikbaar.\n- Uitgesloten van ROD-communicatie: de leerling is uitgesloten van ROD-communicatie en telt niet mee bij de onderwijspositie.\n- VSO advies: de leerling had VSO als basisschooladvies; dit advies is niet bruikbaar voor het bepalen van het verschil tussen de\nonderwijspositie t.o.v. het advies PO.\n- Emigratie: leerlingen die het Nederlands VO verlaten tellen niet mee voor de onderwijspositie.\n- Uitstroom speciaal onderwijs: leerlingen die uitstromen naar het speciaal onderwijs tellen niet mee voor de onderwijspositie.\n- Uitstroom/Geen VO: leerlingen die het Nederlands VO verlaten tellen niet mee voor de onderwijspositie.\n- Internationale leerling: leerlingen met de internationale opleidingen \"International Baccalaureate\" en \"European Secondary School\"\ntellen niet mee voor de onderwijspositie.\n- PrO-leerling: leerlingen die uitstromen naar het praktijkonderwijs tellen niet mee voor de onderwijspositie.\n- VAVO leerling: VAVO-leerlingen tellen niet mee voor de onderwijspositie.\n- Nieuwkomer: de leerling verblijft op 1 oktober van dit schooljaar korter dan 2 jaar in Nederland en telt daarom niet mee voor de\nonderwijspositie.",
			"type": "string",
			"schema": OnderwijspositieUitzondering
		},
		"lb_nm_prestatieanalyse_vso_uitzondering": {
			"type": "string",
			"filter": false,
			"grouping": false,
			"exportable": false
		},
		"lb_nm_schooljaar": {
			"type": "string",
			"label": "Schooljaar",
			"filter": false,
			"grouping": false,
			"exportable": false,
			"allowlist": {
				"beheer": true
			}
		},
		"lb_nm_schooljaar_volgend_pl": {
			"type": "string",
			"filter": false,
			"grouping": false,
			"exportable": false
		},
		"lb_nm_uitstroom": {
			"label": "Uitstroom",
			"filter": false,
			"grouping": false,
			"exportable": false,
			"type": "string",
			"schema": Uitstroom
		},
		"lb_nm_uitstroom_in_schooljaar": {
			"label": "Uitstroom",
			"category": "Instroom - Uitstroom",
			"example": "Extern, Intern, Extern (tussentijds), VAVO, ...",
			"description": "Geeft aan of en op welke manier en welk moment de leerling in dit schooljaar de school verlaat:\n- Extern: de leerling verlaat de instelling en stroomt door naar vervolgonderwijs of anders\n- VAVO: de leerling vertrekt naar de VAVO; hij of zij heeft hierna een VAVO-plaatsing\n- Intern: de leerling stroomt door naar een andere vestiging binnen deze instelling\n\nDit wordt van boven naar beneden bepaald: als een leerling dit schooljaar eerst intern\ndoorstroomt en daarna extern uitstroomt, is dit veld \"Extern\".\nTussentijdse uitstroom (eerder dan 31 juli of 31 mei voor examenleerlingen) wordt\naangegeven met \"(tussentijds)\".",
			"type": "string",
			"schema": Uitstroom
		},
		"lb_nm_uitstroommoment": {
			"filter": false,
			"grouping": false,
			"exportable": false,
			"type": "string",
			"schema": Uitstroommoment
		},
		"lb_nm_uitstroommoment_in_schooljaar": {
			"label": "Uitstroommoment",
			"category": "Instroom - Uitstroom",
			"example": "Einde schooljaar, Tussentijds",
			"description": "Geeft aan of en op welk moment de leerling in dit schooljaar de school verlaat:\n- Einde schooljaar: de uitschrijfdatum (of einddatum van de plaatsing) is op 31 juli (of vanaf 31 mei voor examenleerlingen)\n- Tussentijds: eerder dan 31 juli (of 31 mei voor examenleerlingen)",
			"type": "string",
			"schema": Uitstroommoment
		},
		"lb_nm_uitstroomniveau_vso": {
			"label": "Behaald uitstroomniveau",
			"category": "Prestatieanalyse",
			"example": "MBO niveau 2, HBO, Dagbesteding arbeidsmatig, ...",
			"description": "Het behaalde (eind)uitstroomniveau zoals dit is vastgelegd bij uitschrijvingsgegevens (registratie) van de leerling.\nDit niveau speelt een rol in de Prestatieanalyse voor de indicatoren \"Behaald uitstroomniveau op school conform OPP\" en \"Beoogd i.r.t. behaald einduitstroomniveau\".\nVoor beide indicatoren wordt dit niveau vergeleken met het beoogde uitstroomniveau dat is vastgelegd in het ontwikkelingsperspectief (OPP).",
			"blocklist": {
				"geenVSO": true
			},
			"type": "string",
			"schema": UitstroomniveauVSO
		},
		"lb_nm_uitstroomniveau_vso_status": {
			"type": "string",
			"label": "Uitstroomniveau VSO status",
			"category": "Prestatieanalyse",
			"example": "Geen ontwikkelingsperspectief aanwezig, Geen behaald uitstroomniveau geregistreerd bij uitschrijving, ...",
			"description": "Geeft aan of alle gegevens aanwezig zijn die nodig zijn om voor de Prestatieanalyse de indicatoren \"Behaald uitstroomniveau op school conform OPP\" en \"Beoogd i.r.t. behaald einduitstroomniveau\"\nte bepalen:\n- Informatie volledig: alle gegevens zijn aanwezig\n- Geen ontwikkelingsperspectief aanwezig: de leerling heeft geen ontwikkelingsperspectief (OPP) in Somtoday\n- Geen beoogd uitstroomniveau geregistreerd in OPP: in het nieuwste ontwikkelingsperspectief van de leerling is geen beoogd uitstroomniveau geregistreerd\n- Geen behaald uitstroomniveau geregistreerd bij uitschrijving: bij de uitschrijvingsgegevens van de leerling is geen behaald uitstroomniveau geregistreerd\n- Niet uitgeschreven: de leerling is nog niet uitgeschreven\n- Geen einduitstroom: de leerling is zonder diploma uitgestroomd en valt daarom niet onder einduitstroom",
			"blocklist": {
				"geenVSO": true
			}
		},
		"lb_nm_uitstroomtype": {
			"filter": false,
			"grouping": false,
			"exportable": false,
			"type": "string",
			"schema": Uitstroomtype
		},
		"lb_nm_uitstroomtype_in_schooljaar": {
			"label": "Uitstroomtype",
			"category": "Instroom - Uitstroom",
			"example": "Extern, Intern",
			"description": "Geeft aan of en op welke manier de leerling in dit schooljaar de school verlaat:\n- Extern: de leerling verlaat de instelling en stroomt door naar vervolgonderwijs of anders\n- VAVO: de leerling vertrekt naar de VAVO; hij of zij heeft hierna een VAVO-plaatsing\n- Intern: de leerling stroomt door naar een andere vestiging binnen deze instelling\n\nDit wordt van boven naar beneden bepaald: als een leerling dit schooljaar eerst intern\ndoorstroomt en daarna extern uitstroomt, is dit veld \"Extern\".",
			"type": "string",
			"schema": Uitstroomtype
		},
		"lb_nm_uitstroomtype_vso": {
			"label": "Uitstroomtype (VSO)",
			"category": "Prestatieanalyse",
			"example": "Einduitstroom, Tussentijdse uitstroom",
			"description": "Het type uitstroom waaronder deze leerling valt in de Prestatieanalyse in het VSO:\n- Einduitstroom: de leerling heeft het volledige onderwijsprogramma afgerond met een diploma.\nDit is het geval als de leerling een examendeelname heeft met status Geslaagd, of is uitgeschreven\nmet vertrekstatus \"Geslaagd\". \n- Tussentijdse uitstroom: de leerling verlaat de school zonder diploma. Bij scholen \ndie maar een deel van het onderwijsprogramma aanbieden (bijvoorbeeld de onderbouw), of scholen \ndie gericht zijn op het zo snel mogelijk laten terugkeren/overstappen van leerlingen naar andere\nonderwijsvormen, zullen leerlingen doorgaans tussentijds uitstromen.\n\nN.B. In het VSO heeft tussentijdse uitstroom geen betrekking op het moment in het schooljaar\nwaarop de leerling uitstroomt (zoals bij Uitstroommoment), maar op het wel of niet afronden van\nhet onderwijsprogramma.\n\nHet veld Uitstroomtype VSO is alleen gevuld voor leerlingen op het VSO die uitstromen naar een\nandere onderwijsinstelling of naar de VAVO.",
			"blocklist": {
				"geenVSO": true
			},
			"type": "string",
			"schema": UitstroomtypeVSO
		},
		"lb_nm_vestiging": {
			"type": "string",
			"label": "Vestiging",
			"category": "School",
			"example": "Locatie CumLaude",
			"description": "De vestiging waar deze leerling geplaatst is."
		},
		"lb_nm_vorige_vestiging": {
			"type": "string",
			"label": "Vorige vestiging",
			"category": "School",
			"example": "Locatie CumLaude",
			"description": "Bij een leerling die is gewisseld van vestiging: de laatste vorige vestiging die ongelijk is aan de vestiging van deze plaatsing."
		},
		"lb_nr_beoogd_uitstroomniveau_vso": {
			"type": "number",
			"label": "Uitstroompunten beoogd uitstroomniveau",
			"category": "Prestatieanalyse",
			"example": "5,5 - 11,5",
			"description": "Het aantal punten dat de inspectie toekent aan het in het ontwikkelingsperspectief (OPP) vastgelegde beoogde uitstroomniveau voor deze leerling.\nBij leerlingen met meerdere OPP's is het OPP met de nieuwste begindatum bepalend.\nHet beoogde uitstroomniveau speelt een rol in de Prestatieanalyse voor de indicatoren \"Behaald uitstroomniveau op school conform OPP\" en \"Beoogd i.r.t. behaald einduitstroomniveau\":\nvoor beide indicatoren wordt dit niveau vergeleken met het _behaalde uitstroomniveau_, dat is vastgelegd bij de uitschrijvingsgegevens (registratie) van de leerling.",
			"blocklist": {
				"geenVSO": true
			}
		},
		"lb_nr_examenopstroom": {
			"type": "integer",
			"filter": false,
			"grouping": false,
			"exportable": false,
			"description-magister": "Het aantal keren dat examenopstroom heeft plaatsgevonden voor deze leerling\ntot het moment van deze plaatsing.\nExamenopstroom betekent dat de leerling slaagt voor een bepaald niveau, en\nvervolgens een plaatsing heeft voor een hoger niveau.",
			"description-somtoday": "Het aantal keren dat examenopstroom heeft plaatsgevonden voor deze leerling\ntot het moment van deze plaatsing.\nExamenopstroom betekent dat de leerling slaagt voor een bepaald niveau, en\nvervolgens een plaatsing heeft voor een hoger niveau.\nWanneer in Somtoday het veld \"Diploma behaald\" bij de school van herkomst is\ngevuld met een niveau, en de leerling instroomt in een hoger niveau, dan telt\ndit als één keer examenopstroom."
		},
		"lb_nr_leerjaar": {
			"type": "integer",
			"minimum": 1,
			"maximum": 6,
			"label": "Leerjaar",
			"category": "Opleiding",
			"example": "1, 2, 3, 4, 5, 6",
			"description": "Het leerjaar waarin deze leerling geplaatst is."
		},
		"lb_nr_leerjaar_volgend_sj": {
			"type": "integer",
			"minimum": 1,
			"maximum": 6,
			"filter": false,
			"grouping": false,
			"exportable": false
		},
		"lb_nr_leerling": {
			"type": "integer",
			"filter": false,
			"grouping": false,
			"exportable": false,
			"description": "Het leerlingnummer van deze leerling.",
			"blocklist": {
				"bestuur": true
			}
		},
		"lb_nr_uitstroomniveau_vso": {
			"type": "number",
			"label": "Uitstroompunten behaald uitstroomniveau",
			"category": "Prestatieanalyse",
			"example": "MBO niveau 2, HBO, Dagbesteding arbeidsmatig, ...",
			"description": "Het aantal punten dat de inspectie toekent aan het behaalde (eind)uitstroomniveau zoals dit is vastgelegd bij uitschrijvingsgegevens (registratie) van de leerling.\nDit niveau speelt een rol in de Prestatieanalyse voor de indicatoren \"Behaald uitstroomniveau op school conform OPP\" en \"Beoogd i.r.t. behaald einduitstroomniveau\".\nVoor beide indicatoren wordt dit niveau vergeleken met het _beoogde uitstroomniveau_, dat is vastgelegd in het ontwikkelingsperspectief (OPP).",
			"blocklist": {
				"geenVSO": true
			}
		}
	}
};
